import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { Container } from "./styles";

import logoTopoImg from "../../assets/img/sistema/logos/logo_branco_lg.png";
import logout from "../../assets/img/sistema/logout_btn_branco.svg";
import imgRegulamento from "../../assets/img/sistema/regulamento.svg";
import { toast } from "react-toastify";
import { api } from "../../services/api";
import Loading from "../Loading";

function Topo(props) {
    const hasItemSelect = props?.itemSelect?.label || "";
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const { name } = useSelector((state) => state.user);
    const { dados } = useSelector((state) => state.gerentePlataforma);

    const {
        location: { itemselect },
    } = history;

    const currentItemSelect = hasItemSelect ? hasItemSelect : itemselect?.label;

    const keysGp = (Object.keys(dados[currentItemSelect] || "") || [])[0] || "";
    const idGP = dados[currentItemSelect]?.[keysGp][0]?.acao_id || null;
    const idGC = dados[currentItemSelect]?.[0]?.acao_id || null;
    const id = idGP || idGC;
    const dataGp = dados[currentItemSelect]?.[keysGp] || [];
    const dataGc = dados[currentItemSelect]?.[0] || [];

    const modalTermosGp = dataGp.acao?.exibir_modal_termos;

    const modalTermosGC = dataGc?.acao?.exibir_modal_termos;

    const modalTermos = modalTermosGp || modalTermosGC;

    async function getRegulamento() {
        const nomearquivo = new Date().getTime();
        try {
            setLoading(true);
            const response = await api.request({
                method: "GET",
                url: `/termo/${id}`,
                responseType: "blob",
            });

            if (response.status === 200) {
                const blob = response.data;
                const headers = response.headers["content-type"];
                const type = headers.split("/")[1];
                const reader = new FileReader();
                reader.onload = function () {
                    const buffer = reader.result;
                    const blob = new Blob([buffer], { type: headers });
                    const file = new File([blob], `${nomearquivo}.${type}`, {
                        type: headers,
                    });
                    var pdfURL = window.URL.createObjectURL(file);
                    var tempLink;
                    tempLink = document.createElement("a");
                    tempLink.href = pdfURL;
                    tempLink.setAttribute("download", `${nomearquivo}.${type}`);
                    tempLink.click();
                };

                reader.readAsArrayBuffer(blob);
            } else {
                toast.error("Erro ao buscar o regulamento");
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }

    return (
        <Container>
            <div className="container-logo">
                <Link to="/sistema">
                    <img width={188} src={logoTopoImg} alt="" />
                </Link>
            </div>
            <div className="container-user">
                <p className="nome">Olá, {name}</p>

                {modalTermos ? (
                    <button
                        className="btn-regulamento"
                        onClick={getRegulamento}
                    >
                        <img src={imgRegulamento} alt="" />
                        {loading ? (
                            <Loading height={50} width={50} />
                        ) : (
                            "Regulamento"
                        )}
                    </button>
                ) : (
                    <></>
                )}

                <p
                    onClick={() => {
                        localStorage.removeItem("persist:root");
                        window.location.reload();
                    }}
                >
                    Sair{" "}
                    <img
                        src={logout}
                        style={{ transform: "translate(2px, 4px)" }}
                        alt=""
                    />
                </p>
            </div>
        </Container>
    );
}

export default Topo;
